import styled from "styled-components";

export const Container = styled.main`
    width: 100%;
    height: 100vh;
    background-color: ${props => props.theme.colors.background};
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    form {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        max-width: 350px;
    }
`;

export const Input = styled.input`
    width: 100%;
    max-width: 350px;
    height: 50px;
    border-radius: 25px;
    border: 0.3px solid rgba(0,0,0,.2);
    color: ${props => props.theme.colors.primaryText};
    margin: 10px 0;
    padding: 0 15px;
    text-align: left;

    &:last-child {
        margin-bottom: 20px;
    }
`;

export const Logo = styled.img`
    max-width: 300px;
    margin-bottom: 20px;
`;